import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import BadgeAnalytics from './BadgeAnalytics';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const BadgeAnalyticsDialog = ({
  open,
  onClose,
  analyticsTab,
  handleAnalyticsTabChange,
  popularityStats,
  difficultyStats,
  loadingAnalytics,
  analyticsError,
  getRarityColor,
}) => {
  const { t } = useTranslation(['badges', 'common']);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
        },
      }}
    >
      <DialogTitle>{t('badges:analytics.title')}</DialogTitle>
      <DialogContent>
        <BadgeAnalytics
          analyticsTab={analyticsTab}
          handleAnalyticsTabChange={handleAnalyticsTabChange}
          popularityStats={popularityStats}
          difficultyStats={difficultyStats}
          loadingAnalytics={loadingAnalytics}
          analyticsError={analyticsError}
          getRarityColor={getRarityColor}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common:actions.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BadgeAnalyticsDialog;
